export default "__VITE_ASSET__B4p0sLQP__"